import React, { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Select } from 'grommet';

import { getUserList, getUserFile } from '../../../../api';
import { PageWrapper, Breadcrumbs, MigrationActions, Pagination } from '../../../../components';
import { TableHeader, TableMessages, TableWrap, TableRow, TableCols, TableActionsCol } from '../../../../components/listing';

import { useOpenLayer, useFetchListing } from '../../../../hooks';

import { layers, pagination, messageDictionary, userProfile } from '../../../../constants';

const SearchResult = () => {
  const { migrationId } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [profileFilter, setProfileFilter] = useState('');

  const { open } = useOpenLayer();

  const filters = useMemo(() => ({
    ...(searchTerm && { search: searchTerm }),
    ...(profileFilter && { profile_id: profileFilter })
  }), [searchTerm, profileFilter]);

  const {
    loading,
    list,
    requestError,
    page,

    onNavigate
  } = useFetchListing({
    migrationId,
    get: getUserList,
    filters
  });

  return (
    <PageWrapper>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: '100%'
      }}>
        <MigrationActions />
        <Breadcrumbs />
      </div>

      <TableWrap>
        <TableHeader
          title='Usuários'
          totalItens={list.total}

          download={{
            fileName: 'usuarios.csv',
            resource: getUserFile,
          }}
        />

        <div className='table-filter'>
          <input
            type='search'
            placeholder='Buscar por nome ou email...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='table-filter__input'
          />

          <Select
            options={[{ name: 'Todos os perfis', id: '' }, ...userProfile]}
            value={profileFilter?.toString() ?? ''}
            labelKey='name'
            valueKey={{
              key: 'id',
              reduce: true,
            }}
            emptySearchMessage='Selecione um perfil'
            onChange={({ target }) => setProfileFilter(target.value)}
            className='table-filter__select'
          />
        </div>

        {requestError && (
          <TableMessages message={messageDictionary.requestFail} />
        )}

        {loading && !requestError && (
          <TableMessages message={messageDictionary.waitingResponseRequest} />
        )}

        {!loading && !requestError && list.total <= 0 && (<TableMessages />)}

        {!loading && !requestError && list.data.map((row, index) => (
          <TableRow key={index}>
            <TableCols
              columns={[
                { width: 'small', value: row.full_name },
                { width: 'medium', value: row.email },
                { width: 'small', value: row.profile }
              ]}
            />

            <TableActionsCol
              actions={[
                {
                  label: 'detalhes',
                  action: () => open({ entityIdentifier: row._id, layer: layers.detail }),
                }
              ]}
            />
          </TableRow>
        ))}
      </TableWrap>

      <Pagination
        totalOfRows={list.total}
        page={page}
        perPage={pagination.limit}
        onNavigate={onNavigate}
      />
    </PageWrapper>
  )
}

export default SearchResult;
